module.exports = __webpack_public_path__ + "img/uk.c2c3cadc.svg";